function isOptedInToMarketing() {
    return $('#marketing-opt-in-checkbox').prop('checked');
}

function onContactMethodUpdated(callback) {
    $('#marketing-email-checkbox').on('change', callback);
    $('#marketing-post-checkbox').on('change', callback);
}

function onMarketingOptInToggled(callback) {
    $('#marketing-opt-in-checkbox').on('change', callback);
}

function toggleMarketingContactMethods() {
    $('#marketing-contact-methods').toggle();
}

function deselectAllContactMethods() {
    $('#marketing-email-checkbox').prop('checked', false);
    $('#marketing-post-checkbox').prop('checked', false);
}

function validate() {
    $('#marketing-opt-in-checkbox').parsley().validate();
}

module.exports = {
    deselectAllContactMethods: deselectAllContactMethods,
    isOptedInToMarketing: isOptedInToMarketing,
    onContactMethodUpdated: onContactMethodUpdated,
    onMarketingOptInToggled: onMarketingOptInToggled,
    toggleMarketingContactMethods: toggleMarketingContactMethods,
    validate: validate
};